import { FlexColumn } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import { useRecoilValue } from 'recoil';
import { ASSET_TYPE_CONTAINER } from '../../../constants/asset';
import { useStyles } from '../../../hooks/useStyles';
import { assetState } from '../../../storage/assets';
import { Asset } from '../../../types/asset';
import { isVehicleKind } from '../../../utils/assets';
import AssetData from '../../shared/AssetData';
import AssetHeader from '../../shared/AssetHeader';
import ContainerData from '../../shared/ContainerData';
import VehicleData from '../../shared/VehicleData';

type Props = {
  onClose: () => void;
  isOpen: boolean;
  assetId: string;
  assetData?: Asset;
};

function AssetModal({ onClose, isOpen, assetId, assetData }: Props) {
  const { theme } = useStyles();
  const asset = useRecoilValue(assetState(assetId)) ?? assetData;

  if (!asset) return null;

  const { container, vehicle } = asset;

  return createPortal(
    <Modal
      animate
      closeable
      onClose={onClose}
      isOpen={isOpen}
      size="auto"
    >
      <ModalHeader>
        <AssetHeader asset={asset} />
      </ModalHeader>
      <ModalBody>
        <FlexColumn gap={theme.sizing.scale800}>
          <AssetData asset={asset} />
          {asset.assetType === ASSET_TYPE_CONTAINER && <ContainerData container={container} />}
          {isVehicleKind(asset.assetType) && <VehicleData vehicle={vehicle} />}
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body
  );
}

export default memo(AssetModal);
